<template>
  <modal
    ref="loginModal"
    template="neutral"
    :icon-enabled="false"
    ref-name="loginModal"
    :close-button-enabled="false"
    class="login-modal"
    :class="{ 'login-modal--isLoading': loginLoading }"
  >
    <button
      v-if="!loginLoading"
      class="close-button btn-transparent"
      @click="closeLoginModal"
    >
      <md-icon>clear</md-icon>
    </button>

    <h3 class="login-modal__title">
      <svg-loader
        class="icon-question-modal"
        src="/static/images/login-icon.svg"
      />
      Fazer Login
    </h3>

    <div
      v-if="loginLoading"
      class="login-modal__box-spinner"
    >
      <Spinner />
      <p>Carregando...</p>
    </div>

    <div
      v-else
      class="login-modal__content"
    >
      <p class="login-modal__description">
        Insira seus dados para fazer login e visualizar mais informações deste exame:
      </p>

      <form :disabled="disabled">
        <div class="login-modal__box-inputs">
          <!-- Campo de ID Laboratório -->
          <md-input-container
            :class="{
              'md-input-container--error':
                statusMessages === 'missing-lab' ||
                statusMessages === 'login-missing-both' ||
                statusMessages === 'login-fail',
            }"
          >
            <label for="txtLab">ID Laboratório</label>
            <div class="lab-input">
              <span class="lab-prefix">LAB</span>
              <md-input
                id="txtLab"
                v-model.trim="idLab"
                :readonly.prop="idLabReadonly"
                type="number"
                inputmode="numeric"
                pattern="[0-9]*"
                autocomplete="off"
                maxlength="20"
                min-length="3"
                @click="enableIdLab"
                @keyup.enter.native="attemptLogin"
              />
            </div>
          </md-input-container>

          <template v-if="idLab && idLab.length > 1">
            <md-input-container
              :class="{
                'md-input-container--error':
                  statusMessages === 'missing-username' ||
                  statusMessages === 'login-missing-both' ||
                  statusMessages === 'login-fail',
              }"
            >
              <label for="txtLoginUser">Usuário (E-mail/CPF)</label>
              <md-input
                id="txtLoginUser"
                v-model.trim="username"
                autofocus
                type="text"
                name="username"
                autocomplete="username"
                maxlength="50"
                @keyup.enter.native="attemptLogin"
              />
            </md-input-container>

            <md-input-container
              :class="{
                'md-input-container--error':
                  statusMessages === 'missing-password' ||
                  statusMessages === 'login-missing-both' ||
                  statusMessages === 'login-fail',
              }"
            >
              <label for="txtLoginPassword">Senha</label>
              <md-input
                id="txtLoginPassword"
                v-model.trim="password"
                type="password"
                name="password"
                autocomplete="current-password"
                maxlength="24"
                @keyup.enter.native="attemptLogin"
              />
            </md-input-container>
          </template>

          <div class="error-container">
            <status-message />
          </div>
        </div>

        <md-button
          :disabled="loginLoading"
          class="btn btn-primary"
          @click="attemptLogin"
        >
          Fazer login
          <svg-loader src="/static/images/login-icon.svg" />
        </md-button>
      </form>
    </div>
  </modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import StatusMessages from '@/components/Login/StatusMessages'
import Spinner from '@/components/common/Spinner'

export default {
  name: 'LoginModal',
  components: {
    'status-message': StatusMessages,
    Spinner,
  },
  data: () => ({
    idLab: ' ',
    username: '',
    password: '',
    disabled: false,
    idLabReadonly: true,
  }),
  computed: {
    ...mapGetters(['statusMessages', 'loginLoading', 'profile']),
  },
  methods: {
    ...mapActions(['loginSite']),

    openLoginModal() {
      this.$refs.loginModal.open()
    },
    closeLoginModal() {
      this.$refs.loginModal.close()
    },
    async attemptLogin() {
      await this.$recaptchaLoaded()
      const token = await this.$recaptcha('login')
      this.$recaptchaInstance.hideBadge()

      this.loginSite({
        idLab: this.idLab,
        username: this.username,
        password: this.password,
        recaptchaToken: token,
      })
    },
    enableIdLab() {
      this.idLabReadonly = false
    },
  },
}
</script>

<style lang="scss">
.login-modal {
  font-family: 'Exo 2', sans-serif !important;

  .md-dialog {
    max-width: 480px;
  }

  .md-dialog-title {
    display: none;
  }

  .md-dialog-content {
    padding: 34px;
  }

  .close-button {
    z-index: 90;
    top: 15px;
    right: 24px;
  }

  &--isLoading {
    .md-dialog {
      min-height: 399px;
    }

    .login-modal__box-spinner {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      height: 300px;

      p {
        color: #818181;
        margin-top: 25px;
        text-transform: uppercase;
        font-weight: 600;
      }
    }
  }

  &__title {
    font-size: 20px;
    color: #4a4a4a;
    display: flex;
    align-items: center;

    i {
      margin: 0;
      margin-right: 15px;
    }
  }

  &__description {
    font-size: 16px;
    line-height: 24px;
    color: #4a4a4a;
    margin: 24px 0 !important;
  }

  &__box-inputs {
    padding: 24px;
    background-color: #f5f5f5;
    border-radius: 5px;
    margin-bottom: 24px;
    width: 100%;

    .md-input-container {
      margin-top: 0;

      &:nth-child(3) {
        margin-bottom: 0;
      }
    }
  }

  &__content {
    form {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }

    .btn {
      width: 170px;
      align-items: center;
      display: flex;
      justify-content: center;

      .md-icon {
        margin: 0 0 0 10px;
      }

      svg path {
        fill: #ffffff;
      }
    }
  }

  .lab-input {
    position: relative;
    width: 100%;

    .lab-prefix {
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      color: #666;
      font-weight: 500;
      z-index: 1;
      pointer-events: none;
    }

    .md-input {
      padding-left: 34px !important;

      /* Esconde as setas do input number */
      &::-webkit-outer-spin-button,
      &::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }

      /* Para Firefox */
      &[type='number'] {
        -moz-appearance: textfield;
      }
    }
  }
}
</style>
